(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-home"] && !Shopify.designMode) return;
  try {
    
  import('@theme/component').then(({ Component }) => {
    class MpHomeSwatches extends Component {
      #controller;
      connectedCallback() {
        super.connectedCallback();
        this.#controller?.abort();
        this.#controller = new AbortController();
        this.addEventListener('change', this.handleColor, { capture: true, signal: this.#controller.signal });
      }
      disconnectedCallback() {
        this.#controller?.abort();
        super.disconnectedCallback();
      }
      handleColor = (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.checked || input.disabled) return;
        const { mpPreviewUrl, mpPreviewAlt, mpPreviewPrice, firstAvailableOrFirstVariantId } = input.dataset;
        if (!mpPreviewUrl || !firstAvailableOrFirstVariantId) return;
        const card = this.closest('.mp-campaign__card');
        const image = card?.querySelector('.mp-campaign__picture img');
        const picture = card?.querySelector('.mp-campaign__picture');
        if (!(image instanceof HTMLImageElement) || !(picture instanceof HTMLAnchorElement)) return;
        image.removeAttribute('srcset');
        image.src = mpPreviewUrl;
        image.alt = mpPreviewAlt || '';
        const path = new URL(picture.href).pathname;
        for (const link of card.querySelectorAll('a[href]')) {
          const url = new URL(link.href);
          if (url.pathname !== path || url.origin !== window.location.origin) continue;
          url.searchParams.set('variant', firstAvailableOrFirstVariantId);
          link.href = url.toString();
        }
        const price = card.querySelector('.mp-campaign__price');
        if (price && mpPreviewPrice) price.textContent = mpPreviewPrice;
      };
    }
    if (!customElements.get('mp-home-swatches')) customElements.define('mp-home-swatches', MpHomeSwatches);
  });

  } catch(e) { console.error(e); }
})();
})();
